import React, { useContext } from "react"
import { useTranslation } from "react-i18next"
import { TopMenu } from "../components/TopMenu.jsx"
import { BillingSettings } from "../components/account/BillingSettings.jsx"
import { Delegations } from "../components/account/Delegations.jsx"
import { InvoiceHistory } from "../components/account/InvoiceHistory.jsx"
import { OldKopyPlusBillingSettings } from "../components/account/OldKopyPlusBillingSettings.jsx"
import { GlobalStateContext } from "../components/providers/GlobalStateProvider.jsx"
import { UpdateAccessToken } from "../components/account/UpdateAccessToken.jsx"
import { AliexpressAuth } from "../components/AliexpressAuth.jsx"

const Account = () => {
	const { state, dispatch } = useContext(GlobalStateContext)
	const { t } = useTranslation()

	return (
		<div
			style={{
				width: "100%",
				height: "100%",
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
			}}
		>
			<TopMenu accountSelector storeSelector goBack="/" />

			<div
				className="shadow border"
				style={{
					marginTop: "5rem",
					background: "white",
					borderRadius: "0.6rem",
					width: "450px",
					marginBottom: "2rem",
				}}
			>
				<div
					style={{
						padding: "0.8rem 1rem",
						borderBottom: "1.2px solid #ddd",
						width: "100%",
						display: "flex",
						alignItems: "center",
						justifyContent: "start",
						gap: "0.5rem",
						color: "#0C45DD",
					}}
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="1.6rem"
						height="1.6rem"
						viewBox="0 0 24 24"
					>
						<path
							fill="currentColor"
							d="M5.85 17.1q1.275-.975 2.85-1.538T12 15q1.725 0 3.3.563t2.85 1.537q.875-1.025 1.363-2.325T20 12q0-3.325-2.337-5.663T12 4Q8.675 4 6.337 6.337T4 12q0 1.475.488 2.775T5.85 17.1ZM12 13q-1.475 0-2.488-1.012T8.5 9.5q0-1.475 1.012-2.488T12 6q1.475 0 2.488 1.012T15.5 9.5q0 1.475-1.012 2.488T12 13Zm0 9q-2.075 0-3.9-.788t-3.175-2.137q-1.35-1.35-2.137-3.175T2 12q0-2.075.788-3.9t2.137-3.175q1.35-1.35 3.175-2.137T12 2q2.075 0 3.9.788t3.175 2.137q1.35 1.35 2.138 3.175T22 12q0 2.075-.788 3.9t-2.137 3.175q-1.35 1.35-3.175 2.138T12 22Z"
						></path>
					</svg>
					<h1
						style={{
							fontSize: "1.5rem",
							lineHeight: "1",
							fontWeight: "600",
						}}
					>
						{t("account.my_account")}
					</h1>
					<div
						className="truncate"
						style={{
							padding: "0.1rem 0.4rem",
							borderRadius: "0.5rem",
							background: "#f0f0f0",
							fontSize: "0.65rem",
							fontWeight: "500",
							color: "#777",
						}}
					>
						{state.userEmail}
					</div>
				</div>

				{((state.hasValidKopyBasicSubscription &&
					state.kopyBasicSubscription) ||
					(state.hasValidKopyProtectSubscription &&
						state.kopyProtectSubscription) ||
					(state.hasValidKopyPlusSubscription &&
						state.kopyPlusSubscription)) && <BillingSettings />}

				<InvoiceHistory />

				<Delegations />

				{state.userId === "Ck5IOTAylThpxUlzC9beIlrYYnv1" && (
					<AliexpressAuth />
				)}
			</div>
		</div>
	)
}

export default Account
